import {
  AssetValuationContainer,
  ValuationPricesModule,
} from './valuation.styles';
import { SaleValuation } from './submodules/saleValuation.submodule';
import { RentValuation } from './submodules/rentValuation.submodule';
import { HalfPageModule, SectionTitle } from '../../../styles/global.styles';
import { FormattedMessage } from 'react-intl';
import { ValuationDataModel } from '../../../types/valuation.interface';

export function Valuation(props: ValuationDataModel & { country?: string }) {
  return (
    <HalfPageModule>
      <SectionTitle>
        <FormattedMessage id="valuation.title" />
      </SectionTitle>
      <AssetValuationContainer>
        <ValuationPricesModule>
          {props.reportOperation === 1 && props.excludeRent && (
            <>
              <SaleValuation
                operation={props.reportOperation}
                isExcluded={true}
                data={props.sale}
                reportType={props.reportType}
                estimatedMin={props.sale.estimatedMin ?? null}
                estimatedMax={props.sale.estimatedMax ?? null}
                listingType={props.listingType}
                social_financial={props.social_financial}
                country={props.country}
                yieldValue={props.yieldParam}
              />
            </>
          )}
          {props.reportOperation === 1 && !props.excludeRent && (
            <>
              <SaleValuation
                operation={props.reportOperation}
                isExcluded={false}
                data={props.sale}
                reportType={props.reportType}
                estimatedMin={props.sale.estimatedMin ?? null}
                estimatedMax={props.sale.estimatedMax ?? null}
                listingType={props.listingType}
                social_financial={props.social_financial}
                country={props.country}
                otherOperationFailed={props.saleValuationFailed}
                yieldValue={props.yieldParam}
              />
              <RentValuation
                operation={props.reportOperation}
                isExcluded={false}
                data={props.rent}
                reportType={props.reportType}
                estimatedMin={props.rent.estimatedMin ?? null}
                estimatedMax={props.rent.estimatedMax ?? null}
                listingType={props.listingType}
                social_financial={props.social_financial}
                country={props.country}
                otherOperationFailed={props.rentValuationFailed}
              />
            </>
          )}
          {props.reportOperation === 0 && props.excludeSale && (
            <>
              <RentValuation
                operation={props.reportOperation}
                isExcluded={true}
                data={props.rent}
                reportType={props.reportType}
                estimatedMin={props.rent.estimatedMin ?? null}
                estimatedMax={props.rent.estimatedMax ?? null}
                listingType={props.listingType}
                social_financial={props.social_financial}
                country={props.country}
              />
            </>
          )}
          {props.reportOperation === 0 && !props.excludeSale && (
            <>
              <RentValuation
                operation={props.reportOperation}
                isExcluded={false}
                data={props.rent}
                reportType={props.reportType}
                estimatedMin={props.rent.estimatedMin ?? null}
                estimatedMax={props.rent.estimatedMax ?? null}
                listingType={props.listingType}
                social_financial={props.social_financial}
                country={props.country}
                otherOperationFailed={props.rentValuationFailed}
              />
              <SaleValuation
                operation={props.reportOperation}
                isExcluded={false}
                data={props.sale}
                reportType={props.reportType}
                estimatedMin={props.sale.estimatedMin ?? null}
                estimatedMax={props.sale.estimatedMax ?? null}
                listingType={props.listingType}
                social_financial={props.social_financial}
                country={props.country}
                otherOperationFailed={props.saleValuationFailed}
                yieldValue={props.yieldParam}
              />
            </>
          )}
        </ValuationPricesModule>
      </AssetValuationContainer>
    </HalfPageModule>
  );
}

export function getMethodCellColor(bestMethod: string) {
  if (bestMethod === 'ECO') {
    return {
      formattedMessage: 'valuation.ECO',
      backgroundcolor: '#BCDBD9',
      color: '#0E504C',
    };
  } else if (bestMethod === 'ML1') {
    return {
      formattedMessage: 'valuation.ML',
      backgroundcolor: '#F2DBC8',
      color: '#B56820',
    };
  } else {
    return;
  }
}
